// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "../../../Config.bs.js";
import * as $$String from "../../../../node_modules/rescript/lib/es6/string.js";
import * as Json_encode from "../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as TdsVMMapper from "./VM/TdsVMMapper.bs.js";
import * as TdsRepoManager from "../domain/repo/TdsRepoManager.bs.js";
import * as TdsPdfViewMapper from "./TdsPdfViewMapper.bs.js";
import * as ApiUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as DateTime$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as TdsFormViewMapper from "./TdsFormViewMapper.bs.js";
import * as ErrorUtils$Catalyst from "../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function getPdfDataObj(state, signatureImg) {
  return {
          ownerName: state.formData.ownerName,
          regdAddress: state.formData.regdAddress,
          financialYear: state.formData.financialYear,
          financialYearStartDate: state.formData.financialYearStartDate,
          financialYearEndDate: state.formData.financialYearEndDate,
          ownerPan: state.formData.ownerPan,
          place: state.formData.place,
          signatureImg: signatureImg,
          submitTime: DateTime$Catalyst.toString("DD-MM-YYYY", state.date)
        };
}

function buildPdfData(data) {
  return JSON.stringify(Json_encode.object_({
                  hd: [
                    "ownerName",
                    data.ownerName
                  ],
                  tl: {
                    hd: [
                      "regdAddress",
                      data.regdAddress
                    ],
                    tl: {
                      hd: [
                        "financialYear",
                        data.financialYear
                      ],
                      tl: {
                        hd: [
                          "financialYearStartDate",
                          data.financialYearStartDate
                        ],
                        tl: {
                          hd: [
                            "financialYearEndDate",
                            data.financialYearEndDate
                          ],
                          tl: {
                            hd: [
                              "ownerPan",
                              data.ownerPan
                            ],
                            tl: {
                              hd: [
                                "place",
                                data.place
                              ],
                              tl: {
                                hd: [
                                  "signatureImg",
                                  data.signatureImg
                                ],
                                tl: {
                                  hd: [
                                    "submitTime",
                                    data.submitTime
                                  ],
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }));
}

function getCallbackJson(uuid, date) {
  return JSON.stringify(Json_encode.object_({
                  hd: [
                    "request_uuid",
                    uuid
                  ],
                  tl: {
                    hd: [
                      "declared_at",
                      DateTime$Catalyst.toTimeStamp(date)
                    ],
                    tl: /* [] */0
                  }
                }));
}

function getFileName(state, uuid) {
  return $$String.concat("", {
              hd: "tds_declaration_",
              tl: {
                hd: uuid,
                tl: {
                  hd: state.formData.financialYear,
                  tl: /* [] */0
                }
              }
            });
}

function buildForm(state, uuid, signatureImg) {
  return {
          pdfType: "tds_declaration",
          pdfData: buildPdfData(getPdfDataObj(state, signatureImg)),
          bucketName: "porter-pdf-dev",
          folderName: "tds-declaration",
          fileName: getFileName(state, uuid),
          callbackUrl: $$String.concat("", {
                hd: Config.Env.getHostName(undefined),
                tl: {
                  hd: "/tds_declarations/create",
                  tl: /* [] */0
                }
              }),
          callbackParamsJson: getCallbackJson(uuid, state.date)
        };
}

function TdsFormComponent(Props) {
  var uuid = Props.uuid;
  var tdsFormData = Props.tdsFormData;
  var refreshView = Props.refreshView;
  var initialState_status = TdsVMMapper.getVM(tdsFormData).status;
  var initialState_formData = TdsVMMapper.getVM(tdsFormData);
  var initialState_pdfLink = TdsVMMapper.getVM(tdsFormData).pdfLink;
  var initialState_date = new Date();
  var initialState = {
    requestStatus: /* Init */0,
    status: initialState_status,
    showModal: false,
    formData: initialState_formData,
    pdfFormData: undefined,
    pdfLink: initialState_pdfLink,
    date: initialState_date
  };
  var match = React.useReducer((function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* ToggleModal */0 :
                  return {
                          requestStatus: state.requestStatus,
                          status: state.status,
                          showModal: !state.showModal,
                          formData: state.formData,
                          pdfFormData: state.pdfFormData,
                          pdfLink: state.pdfLink,
                          date: state.date
                        };
              case /* OnCloseModal */1 :
                  return {
                          requestStatus: state.requestStatus,
                          status: state.status,
                          showModal: false,
                          formData: state.formData,
                          pdfFormData: state.pdfFormData,
                          pdfLink: state.pdfLink,
                          date: state.date
                        };
              case /* OnError */2 :
                  return {
                          requestStatus: {
                            TAG: /* Error */2,
                            _0: ErrorUtils$Catalyst.getDefaultErrorEntity("Error while processing", undefined, undefined)
                          },
                          status: state.status,
                          showModal: false,
                          formData: state.formData,
                          pdfFormData: state.pdfFormData,
                          pdfLink: state.pdfLink,
                          date: state.date
                        };
              
            }
          } else {
            if (action.TAG === /* OnSubmitSignature */0) {
              return {
                      requestStatus: {
                        TAG: /* Loading */0,
                        _0: undefined
                      },
                      status: state.status,
                      showModal: state.showModal,
                      formData: state.formData,
                      pdfFormData: action._0,
                      pdfLink: state.pdfLink,
                      date: state.date
                    };
            }
            var result = action._0;
            return {
                    requestStatus: {
                      TAG: /* Live */1,
                      _0: result
                    },
                    status: /* Signed */2,
                    showModal: false,
                    formData: state.formData,
                    pdfFormData: state.pdfFormData,
                    pdfLink: result.pdfUri,
                    date: state.date
                  };
          }
        }), initialState);
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function () {
          var match = state.showModal;
          var match$1 = state.requestStatus;
          if (!match && typeof match$1 !== "number") {
            switch (match$1.TAG | 0) {
              case /* Loading */0 :
                  break;
              case /* Live */1 :
              case /* Error */2 :
                  Curry._1(refreshView, undefined);
                  break;
              
            }
          }
          
        }), [state.showModal]);
  React.useEffect((function () {
          var match = state.requestStatus;
          if (typeof match !== "number" && match.TAG === /* Loading */0 && match._0 === undefined) {
            var RepoInstance = TdsRepoManager.getTdsRepo(undefined);
            var data = state.pdfFormData;
            if (data !== undefined) {
              ApiUtils$Catalyst.handleAPIRequest((function (param) {
                      return Curry._1(RepoInstance.submitTdsForm, data);
                    }), (function (data) {
                      return Curry._1(dispatch, {
                                  TAG: /* OnSuccess */1,
                                  _0: data
                                });
                    }), (function (_error) {
                      return Curry._1(dispatch, /* OnError */2);
                    }));
            }
            
          }
          
        }), [state.requestStatus]);
  var match$1 = state.status;
  if (match$1 >= 2) {
    var pdfLink = state.pdfLink;
    return React.createElement("div", {
                className: "link-component__container"
              }, TdsPdfViewMapper.TdsPdfViewMapper.getView(pdfLink !== undefined ? pdfLink : ""));
  }
  var _result = state.requestStatus;
  if (typeof _result === "number") {
    return React.createElement("div", undefined, TdsFormViewMapper.TdsFormViewMapper.getView(state.formData, DateTime$Catalyst.toString("DD MMM YYYY", state.date), state.showModal, (function (signatureImg) {
                      return Curry._1(dispatch, {
                                  TAG: /* OnSubmitSignature */0,
                                  _0: buildForm(state, uuid, signatureImg)
                                });
                    }), (function (param) {
                      return Curry._1(dispatch, /* ToggleModal */0);
                    })));
  }
  switch (_result.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(LoadingViewComponent$Catalyst.make, {});
    case /* Live */1 :
        return React.createElement("div", undefined, TdsFormViewMapper.TdsFormViewMapper.getView(state.formData, DateTime$Catalyst.toString("DD MMM YYYY", state.date), state.showModal, (function (signatureImg) {
                          return Curry._1(dispatch, {
                                      TAG: /* OnSubmitSignature */0,
                                      _0: buildForm(state, uuid, signatureImg)
                                    });
                        }), (function (param) {
                          return Curry._1(dispatch, /* ToggleModal */0);
                        })));
    case /* Error */2 :
        return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                    error: _result._0
                  });
    
  }
}

var make = TdsFormComponent;

export {
  getPdfDataObj ,
  buildPdfData ,
  getCallbackJson ,
  getFileName ,
  buildForm ,
  make ,
  
}
/* react Not a pure module */
